import Header from '../../components/admin/header/Header'

import Detail from '../../components/admin/faq/Detail';

export default function FaqDetail() {
  return (
    <>
      <Header></Header>
      <Detail />
    </>
  );
}
